module.exports = "<div class=\"notification-stream\" ng-class=\"{'inApp': library.inApp}\"> <div notification-indicator></div> </div>";